import React from "react";
import { useForm } from "react-hook-form";

const Contact = () => {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm();

	const onSubmit = (data) => {
		const { name, phone, message } = data;
		const mailtoLink = `mailto:tecnocge@gmail.com?subject=Nuovo Contatto da sito&body=Nome: ${encodeURIComponent(
			name
		)}%0D%0ATelefono: ${encodeURIComponent(
			phone
		)}%0D%0AMessaggio: ${encodeURIComponent(message)}`;
		window.location.href = mailtoLink;
	};

	return (
		<div
			id="contact"
			className="rts-contact-wrapper-form-area rts-section-gapBottom">
			<div className="container">
				<div className="row g-24">
					<div className="col-lg-7 col-md-12 col-sm-12 col-12">
						<div className="form--area">
							<div className="title-area-left">
								<p className="pre">
									<span>Contattaci</span> in Ogni Momento
								</p>
								<h2 className="title">Scrivici per avere informazioni</h2>
							</div>
							<form onSubmit={handleSubmit(onSubmit)} className="contact-page-form mt--30">
								<div className="name-email-wraper">
									<input
										type="name"
										placeholder="Il tuo nome"
										{...register("name", { required: "Il nome è obbligatorio" })}
									/>
									{errors.name && <p>{errors.name.message}</p>}
								</div>

								<div className="name-email-wraper">
									<input
										type="phone"
										placeholder="Il tuo telefono"
										{...register("phone", {
											required: "Il numero di telefono è obbligatorio",
											pattern: {
												value: /^[0-9+\s-]{7,15}$/,
												message: "Inserisci un numero valido (solo numeri, spazi, + e -)",
											},
										})}
									/>
									{errors.phone && <p>{errors.phone.message}</p>}
								</div>

								<textarea
									placeholder="Cosa vuoi chiederci?"
									{...register("message")}></textarea>
								<button type="submit" className="rts-btn btn-primary">
									Invia messaggio
								</button>
							</form>
						</div>
					</div>
					<div className="col-lg-5 col-md-12 col-sm-12 col-12">
						<div className="map-area-wrapper">
							<iframe
								src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=via Sergio Ramelli 5 Codogno&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
								width="600"
								height="100%"
								style={{ border: "0" }}
								allowFullScreen=""
								loading="lazy"
								referrerPolicy="no-referrer-when-downgrade"></iframe>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Contact;
